import { defineStore } from 'pinia'

const urlLoaderExceptions = [
  '/banks/',
  '/notifications/list_notifications/',
  '/notifications/mark_read/',
  '/products/list_products/',
  '/contacts/list_contacts',
  '/wallets',
  '/clients/',
]

function shouldShowLoader(url = '') {
  return !urlLoaderExceptions.some(exception => url.startsWith(exception))
}

export const useLoadStore = defineStore('loadStore', {
  id: 'load',
  state: () => ({
    loading: false,
    requestsPending: 0,
  }),
  actions: {
    initRequest(url) {
      this.requestsPending += 1
      if (shouldShowLoader(url)) {
        this.loading = true
      }
    },

    finishRequest() {
      this.requestsPending -= 1
      if (this.requestsPending <= 0) {
        this.requestsPending = 0
        this.loading = false
      }
    },
  },
})
